import { connect } from 'react-redux'
import Component from 'components/IssueLimitLists/Operators/Filter'

export default connect(null, null)(Component)
